import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { ChannelMode } from "@/lib/api";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import { MODES, MODE_DOT, MODE_HINT, MODE_LABEL } from "./channel-mode";

export function ModePicker({
  value,
  onChange,
  disabled,
}: {
  value: ChannelMode;
  onChange: (mode: ChannelMode) => void;
  disabled?: boolean;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button variant="outline" size="sm" className="w-48 justify-between font-normal">
          <span className="flex min-w-0 items-center gap-2">
            <span className={cn("size-2 shrink-0 rounded-full", MODE_DOT[value])} />
            <span className="truncate">{MODE_LABEL[value]}</span>
          </span>
          <ChevronDown className="size-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={(v) => onChange(v as ChannelMode)}
        >
          {MODES.map((mode) => (
            <DropdownMenuRadioItem
              key={mode}
              value={mode}
              className="flex-col items-start gap-0.5"
            >
              <span className="flex items-center gap-2">
                <span className={cn("size-2 shrink-0 rounded-full", MODE_DOT[mode])} />
                {MODE_LABEL[mode]}
              </span>
              <span className="text-xs text-muted-foreground">{MODE_HINT[mode]}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
